import { Routes } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from '../app.version.enum';
import { allowedProductGuard, clientConfigAppGuard, isSportsVersionMatch, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const SPORTS_BETSTATION_ROUTES: Routes = [];

const routes: RoutesConfig = {
    routes: [
        {
            path: 'sports',
            children: SPORTS_BETSTATION_ROUTES,
            canMatch: [allowedProductGuard, isSportsVersionMatch(SamePathAppVersion.SPORTS_BETSTATION_APP)],
            canActivate: [clientConfigAppGuard, productUnderMaintenanceGuard],
            data: {
                product: ClientConfigProductName.SPORTS,
                canPreload: [isSportsVersionMatch(SamePathAppVersion.SPORTS_BETSTATION_APP), allowedProductGuard],
            },
        },
    ],
};

export default routes;
